<template>
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Plot Rent Arrears Report</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <!-- Start right Content here -->
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Plot Rent Arrears Report</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Plot Rent</a></li>
                    <li class="breadcrumb-item active">Arrears Report</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Filters Card -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-primary">
                  <h5 class="card-title mb-0 text-white">
                    <i class="mdi mdi-filter-outline me-2"></i>Report Filters
                  </h5>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label">Sub-County</label>
                      <select v-model="selectedSubCounty" class="form-select" @change="onSubCountyChange">
                        <option value="">All Sub-Counties</option>
                        <option v-for="sc in subCounties" :key="sc.subCountyID" :value="sc.subCountyID">
                          {{ sc.subCountyName }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Zone / Market</label>
                      <select v-model="selectedZone" class="form-select" @change="onFilterChange">
                        <option value="">All Zones</option>
                        <option v-for="zone in filteredZones" :key="zone.id" :value="zone.zone">
                          {{ zone.zone }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Date From</label>
                      <input v-model="dateFrom" type="date" class="form-control" @change="onFilterChange">
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Date To</label>
                      <input v-model="dateTo" type="date" class="form-control" @change="onFilterChange">
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Min Arrears (KES)</label>
                      <input v-model="minArrears" type="number" class="form-control" placeholder="0" @change="onFilterChange">
                    </div>
                  </div>
                  <div class="row g-3 mt-2">
                    <div class="col-md-3">
                      <label class="form-label">Search <small class="text-muted">(searches all)</small></label>
                      <div class="input-group">
                        <input v-model="keyword" type="text" class="form-control" placeholder="Plot No, Owner, Phone..." @input="debouncedSearch" @keyup.enter="searchAll">
                        <button class="btn btn-primary" type="button" @click="searchAll" :disabled="!keyword">
                          <i class="mdi mdi-magnify"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Sort By</label>
                      <select v-model="sortBy" class="form-select" @change="onFilterChange">
                        <option value="balance_desc">Highest Arrears</option>
                        <option value="balance_asc">Lowest Arrears</option>
                        <option value="plot_asc">Plot Number A-Z</option>
                        <option value="zone_asc">Zone A-Z</option>
                        <option value="last_payment">Last Payment Date</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Include</label>
                      <select v-model="includeFilter" class="form-select" @change="onFilterChange">
                        <option value="arrears_only">Arrears Only (Balance > 0)</option>
                        <option value="all">All Plots</option>
                        <option value="overpaid">Overpaid (Balance &lt; 0)</option>
                      </select>
                    </div>
                    <div class="col-md-5 d-flex align-items-end gap-2">
                      <button @click="generateReport" class="btn btn-primary" :disabled="loading">
                        <i class="mdi mdi-magnify me-1"></i>Generate Report
                      </button>
                      <button @click="resetFilters" class="btn btn-outline-secondary">
                        <i class="mdi mdi-refresh me-1"></i>Reset
                      </button>
                      <div class="dropdown" v-if="plots.length > 0">
                        <button class="btn btn-success dropdown-toggle" type="button" data-bs-toggle="dropdown">
                          <i class="mdi mdi-download me-1"></i>Download
                        </button>
                        <ul class="dropdown-menu">
                          <li><a class="dropdown-item" href="javascript:void(0)" @click="downloadExcel"><i class="mdi mdi-microsoft-excel me-2 text-success"></i>Excel Report</a></li>

                        </ul>
                      </div>
                      <button v-if="plots.length > 0 && getRight('PLOTRENT BULK SMS')" @click="openBulkSMSModal" class="btn btn-warning">
                        <i class="mdi mdi-message-text-outline me-1"></i>Bulk SMS
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-3" v-if="summary.totalPlots > 0">
            <div class="col-md-2">
              <div class="card mini-stats-wid bg-light">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-1">Total Plots</p>
                      <h4 class="mb-0">{{ numberFormat(summary.totalPlots) }}</h4>
                    </div>
                    <div class="text-primary">
                      <i class="mdi mdi-home-group font-size-24"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid bg-danger bg-soft">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-1">Total Arrears</p>
                      <h4 class="mb-0 text-danger">{{ numberFormat(summary.totalArrears) }}</h4>
                    </div>
                    <div class="text-danger">
                      <i class="mdi mdi-cash-remove font-size-24"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid bg-success bg-soft">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-1">Total Paid (Period)</p>
                      <h4 class="mb-0 text-success">{{ numberFormat(summary.totalPaid) }}</h4>
                    </div>
                    <div class="text-success">
                      <i class="mdi mdi-cash-check font-size-24"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid bg-warning bg-soft">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-1">Avg. Arrears</p>
                      <h4 class="mb-0 text-warning">{{ numberFormat(summary.avgArrears) }}</h4>
                    </div>
                    <div class="text-warning">
                      <i class="mdi mdi-calculator font-size-24"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid bg-info bg-soft">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-1">Never Paid</p>
                      <h4 class="mb-0 text-info">{{ numberFormat(summary.neverPaid) }}</h4>
                    </div>
                    <div class="text-info">
                      <i class="mdi mdi-account-alert font-size-24"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid bg-secondary bg-soft">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-1">Highest Arrears</p>
                      <h4 class="mb-0 text-secondary">{{ numberFormat(summary.highestArrears) }}</h4>
                    </div>
                    <div class="text-secondary">
                      <i class="mdi mdi-arrow-up-bold font-size-24"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Report Table -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white d-flex justify-content-between align-items-center">
                  <h5 class="card-title mb-0">
                    <i class="mdi mdi-table me-2"></i>Arrears Details
                    <span class="badge bg-primary ms-2">{{ totalRecords }} records</span>
                  </h5>
                  <div class="d-flex align-items-center gap-2">
                    <span class="text-muted small">Show:</span>
                    <select v-model="pageSize" class="form-select form-select-sm w-auto" @change="onPageSizeChange">
                      <option :value="50">50</option>
                      <option :value="100">100</option>
                      <option :value="500">500</option>
                      <option :value="1000">1,000</option>
                      <option :value="totalRecords || 10000">All ({{ numberFormat(totalRecords || 0) }})</option>
                    </select>
                  </div>
                </div>

                <div class="card-body p-0">
                  <!-- Loading -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Generating report...</p>
                  </div>

                  <!-- Table -->
                  <div class="table-responsive" v-else>
                    <table class="table table-striped table-hover mb-0">
                      <thead class="table-dark sticky-top">
                      <tr>
                        <th>#</th>
                        <th>Plot Number</th>
                        <th>Zone / Market</th>
                        <th>Owner Details</th>
                        <th>Phone</th>
                        <th class="text-end">Current Balance</th>
                        <th class="text-end">Total Paid</th>
                        <th>Last Payment</th>
                        <th>Payment History</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(plot, index) in plots" :key="plot.id" :class="{'table-danger': parseFloat(plot.currentBalance) > 50000}">
                        <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                        <td>
                          <strong class="text-primary">{{ plot.plotNumber }}</strong>
                        </td>
                        <td>
                          <div>{{ plot.zone }}</div>
                          <small class="text-muted">{{ plot.subCountyName }}</small>
                        </td>
                        <td>
                          <div>{{ plot.ownerNames || '-' }}</div>
                          <small class="text-muted">ID: {{ plot.ownerID || '-' }}</small>
                        </td>
                        <td>
                          <span v-if="plot.ownerPhoneNo">{{ plot.ownerPhoneNo }}</span>
                          <span v-else class="text-muted">-</span>
                        </td>
                        <td class="text-end">
                          <strong :class="parseFloat(plot.currentBalance) > 0 ? 'text-danger' : 'text-success'">
                            KES {{ numberFormat(plot.currentBalance) }}
                          </strong>
                        </td>
                        <td class="text-end">
                          <span class="text-success">KES {{ numberFormat(plot.totalPaid || 0) }}</span>
                        </td>
                        <td>
                            <span v-if="plot.lastPaymentDate">
                              {{ formatDate(plot.lastPaymentDate) }}
                              <div class="small text-muted">{{ getDaysAgo(plot.lastPaymentDate) }}</div>
                            </span>
                          <span v-else class="badge bg-warning">Never Paid</span>
                        </td>
                        <td class="text-center">
                          <button @click="viewPaymentHistory(plot)" class="btn btn-sm btn-outline-info" title="View Payment History">
                            <i class="mdi mdi-history"></i>
                            <span class="badge bg-info ms-1">{{ plot.paymentCount || 0 }}</span>
                          </button>
                        </td>
                        <td>
                          <div class="btn-group">
                            <button @click="viewPlotDetails(plot)" class="btn btn-sm btn-outline-primary" title="View Plot">
                              <i class="mdi mdi-eye"></i>
                            </button>
                            <button v-if="plot.ownerPhoneNo && getRight('PLOTRENT SEND SMS')" @click="sendReminder(plot)" class="btn btn-sm btn-outline-warning" title="Send SMS Reminder">
                              <i class="mdi mdi-message-text"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="plots.length === 0 && !loading">
                        <td colspan="10" class="text-center py-5">
                          <i class="mdi mdi-file-search-outline text-muted" style="font-size: 48px;"></i>
                          <h5 class="mt-3">No Records Found</h5>
                          <p class="text-muted">Adjust your filters and try again</p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white" v-if="plots.length > 0">
                  <nav class="d-flex align-items-center justify-content-between">
                    <div class="text-muted">
                      Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalRecords) }} of {{ totalRecords }} records
                    </div>
                    <ul class="pagination mb-0">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" @click="goToPage(1)" href="javascript:void(0)">First</a>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" @click="goToPage(currentPage - 1)" href="javascript:void(0)">Previous</a>
                      </li>
                      <li class="page-item active">
                        <span class="page-link">{{ currentPage }} / {{ totalPages }}</span>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage >= totalPages }">
                        <a class="page-link" @click="goToPage(currentPage + 1)" href="javascript:void(0)">Next</a>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage >= totalPages }">
                        <a class="page-link" @click="goToPage(totalPages)" href="javascript:void(0)">Last</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>

        </div><!-- container-fluid -->
      </div><!-- page-content -->
    </div><!-- content -->

    <!-- Payment History Modal -->
    <div class="modal fade" id="paymentHistoryModal" tabindex="-1">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header bg-info text-white">
            <h5 class="modal-title text-white">
              <i class="mdi mdi-history me-2"></i>
              Payment History - {{ selectedPlot?.plotNumber }}
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body" v-if="selectedPlot">
            <!-- Plot Summary -->
            <div class="row mb-4">
              <div class="col-md-6">
                <div class="card bg-light mb-0">
                  <div class="card-body py-2">
                    <div class="row">
                      <div class="col-6">
                        <small class="text-muted">Plot Number</small>
                        <div class="fw-bold">{{ selectedPlot.plotNumber }}</div>
                      </div>
                      <div class="col-6">
                        <small class="text-muted">Zone</small>
                        <div>{{ selectedPlot.zone }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card bg-light mb-0">
                  <div class="card-body py-2">
                    <div class="row">
                      <div class="col-6">
                        <small class="text-muted">Owner</small>
                        <div>{{ selectedPlot.ownerNames || '-' }}</div>
                      </div>
                      <div class="col-6">
                        <small class="text-muted">Current Balance</small>
                        <div class="fw-bold" :class="parseFloat(selectedPlot.currentBalance) > 0 ? 'text-danger' : 'text-success'">
                          KES {{ numberFormat(selectedPlot.currentBalance) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Payment History Summary -->
            <div class="row mb-3" v-if="paymentHistory.length > 0">
              <div class="col-4">
                <div class="text-center p-2 bg-success bg-soft rounded">
                  <div class="text-muted small">Total Payments</div>
                  <div class="fw-bold text-success">{{ paymentHistory.length }}</div>
                </div>
              </div>
              <div class="col-4">
                <div class="text-center p-2 bg-primary bg-soft rounded">
                  <div class="text-muted small">Total Amount Paid</div>
                  <div class="fw-bold text-primary">KES {{ numberFormat(paymentHistorySummary.totalPaid) }}</div>
                </div>
              </div>
              <div class="col-4">
                <div class="text-center p-2 bg-info bg-soft rounded">
                  <div class="text-muted small">Avg. Payment</div>
                  <div class="fw-bold text-info">KES {{ numberFormat(paymentHistorySummary.avgPayment) }}</div>
                </div>
              </div>
            </div>

            <!-- Date Range Filter -->
            <div class="row mb-3">
              <div class="col-md-4">
                <input v-model="historyDateFrom" type="date" class="form-control form-control-sm" placeholder="From">
              </div>
              <div class="col-md-4">
                <input v-model="historyDateTo" type="date" class="form-control form-control-sm" placeholder="To">
              </div>
              <div class="col-md-4">
                <button @click="loadPaymentHistory(selectedPlot)" class="btn btn-sm btn-primary">
                  <i class="mdi mdi-filter"></i> Filter
                </button>
              </div>
            </div>

            <!-- Payment History Table -->
            <div class="table-responsive" style="max-height: 400px;">
              <table class="table table-sm table-striped">
                <thead class="table-dark sticky-top">
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th class="text-end">Paid</th>
                  <th class="text-end">Balance After</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(payment, index) in paymentHistory" :key="payment.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ formatDate(payment.dateCreated || payment.transactionDate) }}</td>
                  <td class="text-end text-success fw-bold">KES {{ numberFormat(payment.amount) }}</td>
                  <td class="text-end">KES {{ numberFormat(payment.balanceAfter) }}</td>
                </tr>
                <tr v-if="paymentHistory.length === 0">
                  <td colspan="4" class="text-center py-4 text-muted">
                    <i class="mdi mdi-cash-remove font-size-24"></i>
                    <div>No payment records found</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="printPaymentHistory" class="btn btn-outline-primary" v-if="paymentHistory.length > 0">
              <i class="mdi mdi-printer me-1"></i>Print
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Send SMS Reminder Modal -->
    <div class="modal fade" id="reminderModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-warning">
            <h5 class="modal-title">
              <i class="mdi mdi-message-text me-2"></i>Send Payment Reminder
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body" v-if="selectedPlot">
            <div class="card bg-light mb-3">
              <div class="card-body py-2">
                <div class="row">
                  <div class="col-6">
                    <small class="text-muted">Plot:</small>
                    <div class="fw-bold">{{ selectedPlot.plotNumber }}</div>
                  </div>
                  <div class="col-6">
                    <small class="text-muted">Balance:</small>
                    <div class="fw-bold text-danger">KES {{ numberFormat(selectedPlot.currentBalance) }}</div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-6">
                    <small class="text-muted">Owner:</small>
                    <div>{{ selectedPlot.ownerNames || '-' }}</div>
                  </div>
                  <div class="col-6">
                    <small class="text-muted">Zone:</small>
                    <div>{{ selectedPlot.zone }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">Phone Number <span class="text-danger">*</span></label>
              <input v-model="reminderPhone" type="text" class="form-control" placeholder="07XXXXXXXX">
            </div>

            <div class="alert alert-warning mb-0">
              <i class="mdi mdi-alert me-2"></i>
              <strong>Urgent Notice:</strong> SMS will include 7-day payment deadline warning and enforcement action notice. Plot owner will be advised to visit the County Revenue Office.
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button @click="confirmSendReminder" class="btn btn-warning" :disabled="!reminderPhone || sendingSMS">
              <span v-if="sendingSMS">
                <span class="spinner-border spinner-border-sm me-1"></span>Sending...
              </span>
              <span v-else>
                <i class="mdi mdi-send me-1"></i>Send SMS
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Bulk SMS Modal -->
    <div class="modal fade" id="bulkSMSModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-warning">
            <h5 class="modal-title">
              <i class="mdi mdi-message-text-outline me-2"></i>Send Bulk SMS Reminders
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning">
              <i class="mdi mdi-alert me-2"></i>
              <strong>Warning:</strong> This will send SMS reminders to all plot owners with phone numbers in the current filtered results.
            </div>

            <div class="card bg-light mb-3">
              <div class="card-body">
                <div class="row text-center">
                  <div class="col-4">
                    <div class="text-muted small">Total Plots</div>
                    <div class="fw-bold text-primary">{{ totalRecords }}</div>
                  </div>
                  <div class="col-4">
                    <div class="text-muted small">With Phone</div>
                    <div class="fw-bold text-success">{{ plotsWithPhone }}</div>
                  </div>
                  <div class="col-4">
                    <div class="text-muted small">No Phone</div>
                    <div class="fw-bold text-danger">{{ totalRecords - plotsWithPhone }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">Current Filters Applied:</label>
              <ul class="list-unstyled mb-0 small">
                <li v-if="selectedSubCounty"><i class="mdi mdi-check text-success me-1"></i>Sub-County: {{ getSubCountyName(selectedSubCounty) }}</li>
                <li v-if="selectedZone"><i class="mdi mdi-check text-success me-1"></i>Zone: {{ selectedZone }}</li>
                <li v-if="minArrears"><i class="mdi mdi-check text-success me-1"></i>Min Arrears: KES {{ numberFormat(minArrears) }}</li>
                <li v-if="!selectedSubCounty && !selectedZone && !minArrears" class="text-muted">No filters applied - All plots with arrears</li>
              </ul>
            </div>

            <div class="alert alert-warning mb-0">
              <i class="mdi mdi-alert me-2"></i>
              <strong>Urgent Notice:</strong> All recipients will receive 7-day payment deadline warning and enforcement action notice.
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button @click="confirmBulkSMS" class="btn btn-warning" :disabled="sendingBulkSMS || plotsWithPhone === 0">
              <span v-if="sendingBulkSMS">
                <span class="spinner-border spinner-border-sm me-1"></span>Sending...
              </span>
              <span v-else>
                <i class="mdi mdi-send me-1"></i>Send to {{ plotsWithPhone }} Recipients
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Plot Details Modal -->
    <div class="modal fade" id="plotDetailsModal" tabindex="-1">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title text-white">
              <i class="mdi mdi-home-city me-2"></i>
              Plot Details - {{ plotDetails?.plotNumber }}
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body" v-if="plotDetails">
            <!-- Plot Information -->
            <div class="card mb-3">
              <div class="card-header bg-light py-2">
                <h6 class="mb-0"><i class="mdi mdi-map-marker me-2"></i>Plot Information</h6>
              </div>
              <div class="card-body py-2">
                <div class="row">
                  <div class="col-md-3">
                    <small class="text-muted">Plot Number</small>
                    <div class="fw-bold text-primary">{{ plotDetails.plotNumber }}</div>
                  </div>
                  <div class="col-md-3">
                    <small class="text-muted">Zone / Market</small>
                    <div>{{ plotDetails.zone }}</div>
                  </div>
                  <div class="col-md-3">
                    <small class="text-muted">Sub-County</small>
                    <div>{{ plotDetails.subCountyName }}</div>
                  </div>
                  <div class="col-md-3">
                    <small class="text-muted">Ward</small>
                    <div>{{ plotDetails.wardName }}</div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-3">
                    <small class="text-muted">Plot Size</small>
                    <div>{{ plotDetails.plotSize || '-' }}</div>
                  </div>
                  <div class="col-md-3">
                    <small class="text-muted">Status</small>
                    <div>
                      <span class="badge" :class="{
                        'bg-success': plotDetails.status === 'Active',
                        'bg-warning': plotDetails.status === 'Vacant',
                        'bg-info': plotDetails.status === 'Transferred',
                        'bg-danger': plotDetails.status === 'Suspended'
                      }">{{ plotDetails.status }}</span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <small class="text-muted">Last Billing Year</small>
                    <div>{{ plotDetails.lastBillingYear || '-' }}</div>
                  </div>
                  <div class="col-md-3">
                    <small class="text-muted">Last Payment Date</small>
                    <div>{{ plotDetails.lastPaymentDate ? formatDate(plotDetails.lastPaymentDate) : 'Never' }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Owner Information -->
            <div class="card mb-3">
              <div class="card-header bg-light py-2">
                <h6 class="mb-0"><i class="mdi mdi-account me-2"></i>Owner Information</h6>
              </div>
              <div class="card-body py-2">
                <div class="row">
                  <div class="col-md-6">
                    <small class="text-muted">Owner Name</small>
                    <div class="fw-bold">{{ plotDetails.ownerNames || '-' }}</div>
                  </div>
                  <div class="col-md-6">
                    <small class="text-muted">ID Number</small>
                    <div>{{ plotDetails.ownerID || '-' }}</div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-6">
                    <small class="text-muted">Phone Number</small>
                    <div>{{ plotDetails.ownerPhoneNo || '-' }}</div>
                  </div>
                  <div class="col-md-6">
                    <small class="text-muted">Email</small>
                    <div>{{ plotDetails.ownerEmail || '-' }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Financial Summary -->
            <div class="card mb-0">
              <div class="card-header bg-light py-2">
                <h6 class="mb-0"><i class="mdi mdi-cash-multiple me-2"></i>Financial Summary</h6>
              </div>
              <div class="card-body py-2">
                <div class="row text-center">
                  <div class="col-md-4 col-6 mb-2">
                    <div class="p-2 bg-info bg-soft rounded">
                      <small class="text-muted d-block">Annual Rent</small>
                      <div class="fw-bold text-info">KES {{ numberFormat(plotDetails.annualRent) }}</div>
                    </div>
                  </div>
                  <div class="col-md-4 col-6 mb-2">
                    <div class="p-2 bg-warning bg-soft rounded">
                      <small class="text-muted d-block">Arrears B/F</small>
                      <div class="fw-bold text-warning">KES {{ numberFormat(plotDetails.arrearsForward) }}</div>
                    </div>
                  </div>
                  <div class="col-md-4 col-6 mb-2">
                    <div class="p-2 bg-secondary bg-soft rounded">
                      <small class="text-muted d-block">Total Billed</small>
                      <div class="fw-bold text-secondary">KES {{ numberFormat(plotDetails.totalBilled) }}</div>
                    </div>
                  </div>
                  <div class="col-md-4 col-6 mb-2">
                    <div class="p-2 bg-success bg-soft rounded">
                      <small class="text-muted d-block">Total Payments</small>
                      <div class="fw-bold text-success">KES {{ numberFormat(plotDetails.totalPayments) }}</div>
                    </div>
                  </div>
                  <div class="col-md-4 col-6 mb-2">
                    <div class="p-2 bg-purple bg-soft rounded" style="background-color: rgba(111, 66, 193, 0.1);">
                      <small class="text-muted d-block">Penalties</small>
                      <div class="fw-bold" style="color: #6f42c1;">KES {{ numberFormat(plotDetails.accumulatedPenalty) }}</div>
                    </div>
                  </div>
                  <div class="col-md-4 col-6 mb-2">
                    <div class="p-2 rounded" :class="parseFloat(plotDetails.currentBalance) > 0 ? 'bg-danger bg-soft' : 'bg-success bg-soft'">
                      <small class="text-muted d-block">Current Balance</small>
                      <div class="fw-bold" :class="parseFloat(plotDetails.currentBalance) > 0 ? 'text-danger' : 'text-success'">
                        KES {{ numberFormat(plotDetails.currentBalance) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body text-center py-5" v-else-if="loadingPlotDetails">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2 text-muted">Loading plot details...</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

  </div><!-- layout-wrapper -->
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { execute, plotRent, getRight } from "@/api";

export default {
  name: "PlotRentArrearsReport",
  components: { NavigationBar },
  data() {
    return {
      // Filter options
      subCounties: [],
      zones: [],

      // Selected filters
      selectedSubCounty: '',
      selectedZone: '',
      dateFrom: '',
      dateTo: '',
      minArrears: '',
      keyword: '',
      sortBy: 'balance_desc',
      includeFilter: 'arrears_only',

      // Report data
      plots: [],
      summary: {
        totalPlots: 0,
        totalArrears: 0,
        totalPaid: 0,
        avgArrears: 0,
        neverPaid: 0,
        highestArrears: 0
      },

      // Pagination
      currentPage: 1,
      pageSize: 50,
      totalPages: 1,
      totalRecords: 0,

      // Payment history modal
      selectedPlot: null,
      paymentHistory: [],
      paymentHistorySummary: { totalPaid: 0, avgPayment: 0 },
      historyDateFrom: '',
      historyDateTo: '',

      // SMS
      reminderPhone: '',
      sendingSMS: false,
      sendingBulkSMS: false,

      // State
      loading: false,
      searchTimeout: null
    }
  },
  computed: {
    filteredZones() {
      return this.zones;
    },
    plotsWithPhone() {
      return this.plots.filter(p => p.ownerPhoneNo && p.ownerPhoneNo.trim() !== '').length;
    }
  },
  mounted() {
    this.loadSubCounties();
    this.loadZones();
    this.setDefaultDates();

    // Auto-generate report on page load
    this.$nextTick(() => {
      this.generateReport();
    });
  },
  methods: {
    getRight(type) {
      return getRight(type);
    },

    setDefaultDates() {
      const today = new Date();
      const year = today.getMonth() >= 6 ? today.getFullYear() : today.getFullYear() - 1;
      this.dateFrom = `${year}-07-01`;
      this.dateTo = today.toISOString().split('T')[0];
    },

    loadSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounties");

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties || res.data.data || [];
            }
          })
          .catch((e) => console.error(e));
    },

    loadZones() {
      const data = new FormData();
      data.append("function", "getZones");
      data.append("subCountyID", this.selectedSubCounty);

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success) {
              this.zones = res.data.data.zones || res.data.data || [];
            }
          })
          .catch((e) => console.error(e));
    },

    onSubCountyChange() {
      this.selectedZone = '';
      this.loadZones();
      this.currentPage = 1;
      this.generateReport();
    },

    getSubCountyName(id) {
      const sc = this.subCounties.find(s => s.subCountyID == id);
      return sc ? sc.subCountyName : id;
    },

    generateReport() {
      this.loading = true;
      this.plots = [];

      const data = new FormData();
      data.append("function", "getArrearsReport");
      data.append("subCountyID", this.selectedSubCounty);
      data.append("zone", this.selectedZone);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("minArrears", this.minArrears);
      data.append("keyword", this.keyword);
      data.append("sortBy", this.sortBy);
      data.append("includeFilter", this.includeFilter);
      data.append("page", this.currentPage);
      data.append("rows_per_page", parseInt(this.pageSize));

      execute(data, plotRent)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.plots = res.data.data.plots || [];
              this.summary = res.data.data.summary || {};
              this.totalRecords = res.data.data.count?.count || 0;
              this.totalPages = Math.ceil(this.totalRecords / parseInt(this.pageSize));
            } else {
              alert("Error: " + res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error(e);
            alert("Error loading report: " + e.message);
          });
    },

    resetFilters() {
      this.selectedSubCounty = '';
      this.selectedZone = '';
      this.minArrears = '';
      this.keyword = '';
      this.sortBy = 'balance_desc';
      this.includeFilter = 'arrears_only';
      this.currentPage = 1;
      this.setDefaultDates();
      this.loadZones(); // Reload all zones
      this.generateReport();
    },

    goToPage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      this.generateReport();
    },

    onPageSizeChange() {
      this.currentPage = 1; // Reset to first page when changing page size
      this.generateReport();
    },

    onFilterChange() {
      this.currentPage = 1; // Reset to first page when filter changes
      this.generateReport();
    },

    searchAll() {
      // Search ignores all other filters - searches across all plots
      this.currentPage = 1;
      this.loading = true;
      this.plots = [];

      const data = new FormData();
      data.append("function", "getArrearsReport");
      data.append("subCountyID", ""); // Ignore sub-county
      data.append("zone", ""); // Ignore zone
      data.append("dateFrom", ""); // Ignore date from
      data.append("dateTo", ""); // Ignore date to
      data.append("minArrears", ""); // Ignore min arrears
      data.append("keyword", this.keyword);
      data.append("sortBy", this.sortBy);
      data.append("includeFilter", "all"); // Search all plots regardless of balance
      data.append("page", this.currentPage);
      data.append("rows_per_page", parseInt(this.pageSize));

      execute(data, plotRent)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.plots = res.data.data.plots || [];
              this.summary = res.data.data.summary || {};
              this.totalRecords = res.data.data.count?.count || 0;
              this.totalPages = Math.ceil(this.totalRecords / parseInt(this.pageSize));
            } else {
              alert("Error: " + res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error(e);
            alert("Error searching: " + e.message);
          });
    },

    debouncedSearch() {
      // Clear previous timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // Set new timeout - wait 500ms after user stops typing
      this.searchTimeout = setTimeout(() => {
        if (this.keyword && this.keyword.length >= 2) {
          this.searchAll();
        } else if (!this.keyword) {
          // If search is cleared, go back to filtered view
          this.generateReport();
        }
      }, 500);
    },

    viewPaymentHistory(plot) {
      this.selectedPlot = plot;
      this.historyDateFrom = this.dateFrom;
      this.historyDateTo = this.dateTo;
      this.loadPaymentHistory(plot);

      const modal = new bootstrap.Modal(document.getElementById('paymentHistoryModal'));
      modal.show();
    },

    loadPaymentHistory(plot) {
      const data = new FormData();
      data.append("function", "getPlotPaymentHistory");
      data.append("plotID", plot.id);
      data.append("dateFrom", this.historyDateFrom);
      data.append("dateTo", this.historyDateTo);

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success) {
              this.paymentHistory = res.data.data.payments || [];

              const totalPaid = this.paymentHistory.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);
              this.paymentHistorySummary = {
                totalPaid: totalPaid,
                avgPayment: this.paymentHistory.length > 0 ? totalPaid / this.paymentHistory.length : 0
              };
            }
          })
          .catch((e) => console.error(e));
    },

    viewPlotDetails(plot) {
      // Set sessionStorage for PlotStatements page
      sessionStorage.setItem("plotID", plot.id);
      sessionStorage.setItem("plotNumber", plot.plotNumber);
      sessionStorage.setItem("plotZone", plot.zone);

      this.$router.push('/plot-statements');
    },

    sendReminder(plot) {
      this.selectedPlot = plot;
      this.reminderPhone = plot.ownerPhoneNo || '';

      const modal = new bootstrap.Modal(document.getElementById('reminderModal'));
      modal.show();
    },

    confirmSendReminder() {
      if (!this.reminderPhone) {
        alert("Please enter phone number");
        return;
      }

      this.sendingSMS = true;

      const data = new FormData();
      data.append("function", "sendArrearsReminder");
      data.append("plotID", this.selectedPlot.id);
      data.append("phone", this.reminderPhone);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, plotRent)
          .then((res) => {
            this.sendingSMS = false;

            if (res.data.success) {
              alert("SMS reminder sent successfully!");
              this.closeModal('reminderModal');
            } else {
              alert("Failed: " + res.data.message);
            }
          })
          .catch((e) => {
            this.sendingSMS = false;
            alert("Error: " + e.message);
          });
    },

    openBulkSMSModal() {
      const modal = new bootstrap.Modal(document.getElementById('bulkSMSModal'));
      modal.show();
    },

    confirmBulkSMS() {
      if (this.plotsWithPhone === 0) {
        alert("No plots with phone numbers in current results");
        return;
      }

      if (!confirm(`Are you sure you want to send SMS to ${this.plotsWithPhone} recipients?`)) {
        return;
      }

      this.sendingBulkSMS = true;

      const data = new FormData();
      data.append("function", "sendBulkArrearsReminder");
      data.append("subCountyID", this.selectedSubCounty);
      data.append("zone", this.selectedZone);
      data.append("minArrears", this.minArrears);
      data.append("includeFilter", this.includeFilter);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, plotRent)
          .then((res) => {
            this.sendingBulkSMS = false;

            if (res.data.success) {
              alert(`Bulk SMS initiated!\n\nTotal: ${res.data.data.totalRecipients}\nSent: ${res.data.data.successCount}\nFailed: ${res.data.data.failedCount}`);
              this.closeModal('bulkSMSModal');
            } else {
              alert("Failed: " + res.data.message);
            }
          })
          .catch((e) => {
            this.sendingBulkSMS = false;
            alert("Error: " + e.message);
          });
    },

    downloadExcel() {
      this.generateClientExcel();
    },

    generateClientExcel() {
      let csv = 'Plot Number,Zone,Sub-County,Owner Name,Owner ID,Phone,Current Balance,Total Paid,Last Payment Date\n';

      this.plots.forEach(plot => {
        csv += `"${plot.plotNumber}","${plot.zone}","${plot.subCountyName || ''}","${plot.ownerNames || ''}","${plot.ownerID || ''}","${plot.ownerPhoneNo || ''}",${plot.currentBalance},${plot.totalPaid || 0},"${plot.lastPaymentDate || ''}"\n`;
      });

      const blob = new Blob([csv], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Arrears_Report_${new Date().toISOString().split('T')[0]}.csv`;
      a.click();
      window.URL.revokeObjectURL(url);
    },

    downloadPDF() {
      const data = new FormData();
      data.append("function", "exportArrearsReportPDF");
      data.append("subCountyID", this.selectedSubCounty);
      data.append("zone", this.selectedZone);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("minArrears", this.minArrears);
      data.append("sortBy", this.sortBy);
      data.append("includeFilter", this.includeFilter);

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success && res.data.data.fileUrl) {
              window.open(res.data.data.fileUrl, '_blank');
            } else {
              alert("PDF generation - Please contact admin");
            }
          })
          .catch((e) => alert("Error: " + e.message));
    },

    downloadDetailedExcel() {
      const data = new FormData();
      data.append("function", "exportArrearsReportDetailed");
      data.append("subCountyID", this.selectedSubCounty);
      data.append("zone", this.selectedZone);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("minArrears", this.minArrears);
      data.append("includeFilter", this.includeFilter);

      execute(data, plotRent)
          .then((res) => {
            if (res.data.success && res.data.data.fileUrl) {
              window.open(res.data.data.fileUrl, '_blank');
            } else {
              alert("Detailed export - Please contact admin");
            }
          })
          .catch((e) => alert("Error: " + e.message));
    },

    printPaymentHistory() {
      window.print();
    },

    closeModal(modalId) {
      const modal = bootstrap.Modal.getInstance(document.getElementById(modalId));
      if (modal) modal.hide();
    },

    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    },

    getDaysAgo(date) {
      if (!date) return '';
      const days = Math.floor((new Date() - new Date(date)) / (1000 * 60 * 60 * 24));
      if (days === 0) return 'Today';
      if (days === 1) return 'Yesterday';
      if (days < 30) return `${days} days ago`;
      if (days < 365) return `${Math.floor(days / 30)} months ago`;
      return `${Math.floor(days / 365)} years ago`;
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    getPaymentModeBadge(mode) {
      switch (mode?.toUpperCase()) {
        case 'MPESA': return 'bg-success';
        case 'CASH': return 'bg-primary';
        case 'BANK': return 'bg-info';
        case 'CHEQUE': return 'bg-warning text-dark';
        case 'ADJUSTMENT': return 'bg-secondary';
        case 'REVERSAL': return 'bg-danger';
        default: return 'bg-secondary';
      }
    }
  }
}
</script>

<style scoped>
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 10;
}
.mini-stats-wid .card-body {
  padding: 0.75rem;
}
.table-danger {
  background-color: rgba(220, 53, 69, 0.1) !important;
}
</style>